import { render, staticRenderFns } from "./CourseMaterials.vue?vue&type=template&id=270a9c8d&scoped=true&"
import script from "./CourseMaterials.vue?vue&type=script&lang=ts&"
export * from "./CourseMaterials.vue?vue&type=script&lang=ts&"
import style0 from "./CourseMaterials.vue?vue&type=style&index=0&id=270a9c8d&lang=scss&scoped=true&"
import style1 from "./CourseMaterials.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a9c8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VBtn,VCard,VContent})
